import { render, staticRenderFns } from "./RsaPazientePriProgettoRiabilitativoIndividualeEditComponent.vue?vue&type=template&id=df2e843e"
import script from "./RsaPazientePriProgettoRiabilitativoIndividualeEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePriProgettoRiabilitativoIndividualeEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports